import AboutPage from './AboutPage'

export default AboutPage;
